import ATableAccess from "./aTableAccess";

class PersonAccess extends ATableAccess {}

export default PersonAccess;
